import React from "react";
import KC_Heading3 from "../../typography/KC-Heading/KC_Heading3";
import KC_Toggle from "../../KC_FormInput/KC_Toggle";
import { KC_CardTitleProps } from "./model/KC_CardTitleProps";
import "./styles.scss";

export const KC_CardTitle: React.FC<KC_CardTitleProps> = (props) => (
  <div className="w-100 d-flex justify-content-between pt-2">
    <KC_Heading3
      text={props.title}
      className={`${props.titleClassName || ""} d-flex align-items-center justify-content-center`}
    />
    {props.useRemove && (
      <KC_Toggle
        id="debug"
        isChecked={!!props.isSelected}
        onToggle={props.handleRemove}
        className={props.isOnboarding ? "toggle" : ""}
      />
    )}
  </div>
);
